import { Button } from "../components/ui/button";
import { CheckCircle, FileText, AlertTriangle, Sparkles, DollarSign } from "lucide-react";

const ArtworkQualityAlert = ({ qualityAnalysis, onAcceptFee }) => {
  if (!qualityAnalysis || qualityAnalysis.status === "excellent") return null;

  const getAlertStyles = (status) => {
    switch (status) {
      case "needs_work":
        return "border-red-200 bg-red-50";
      case "auto_vectorizable":
        return "border-blue-200 bg-blue-50";
      case "acceptable":
        return "border-yellow-200 bg-yellow-50";
      default:
        return "border-gray-200 bg-gray-50";
    }
  };

  const getIcon = (status) => {
    switch (status) {
      case "needs_work":
        return <AlertTriangle className="w-5 h-5 text-red-500" />;
      case "auto_vectorizable":
        return <Sparkles className="w-5 h-5 text-blue-500" />;
      case "acceptable":
        return <CheckCircle className="w-5 h-5 text-yellow-500" />;
      default:
        return <FileText className="w-5 h-5 text-gray-500" />;
    }
  };

  return (
    <div className={`mt-4 p-4 rounded-lg border ${getAlertStyles(qualityAnalysis.status)}`}>
      <div className="flex items-start space-x-3">
        {getIcon(qualityAnalysis.status)}
        <div className="flex-1">
          <h4 className="font-semibold text-gray-900 mb-2">
            {qualityAnalysis.message}
          </h4>
          
          {qualityAnalysis.issues && qualityAnalysis.issues.length > 0 && (
            <div className="mb-2">
              <p className="text-sm font-medium text-gray-700 mb-1">Issues detected:</p>
              <ul className="text-sm text-gray-600 list-disc list-inside">
                {qualityAnalysis.issues.map((issue, index) => (
                  <li key={index}>{issue}</li>
                ))}
              </ul>
            </div>
          )}
          
          {qualityAnalysis.recommendations && qualityAnalysis.recommendations.length > 0 && (
            <div className="mb-2">
              <p className="text-sm font-medium text-gray-700 mb-1">Recommendations:</p>
              <ul className="text-sm text-gray-600 list-disc list-inside">
                {qualityAnalysis.recommendations.map((rec, index) => (
                  <li key={index}>{rec}</li>
                ))}
              </ul>
            </div>
          )}

          {qualityAnalysis.needs_art_fee && (
            <div className="mt-3 p-3 bg-white border border-orange-200 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <DollarSign className="w-4 h-4 text-orange-500" />
                <span className="font-semibold text-orange-800">$25 Art Fee Required</span>
              </div>
              <p className="text-sm text-orange-700 mb-3">
                Our designers will enhance your artwork to ensure perfect print quality. 
                This includes color optimization, resolution enhancement, and format conversion.
              </p>
              <Button
                size="sm"
                variant="outline"
                onClick={() => onAcceptFee && onAcceptFee()}
                className="border-orange-300 text-orange-700 hover:bg-orange-50"
              >
                Accept Art Fee (+$25)
              </Button>
            </div>
          )}

          {qualityAnalysis.status === 'good' && !qualityAnalysis.needs_art_fee && (
            <div className="mt-3 p-3 bg-white border border-green-200 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <CheckCircle className="w-4 h-4 text-green-500" />
                <span className="font-semibold text-green-800">Good Quality</span>
              </div>
              <p className="text-sm text-green-700">
                Your artwork looks great and is ready for printing!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export { ArtworkQualityAlert };
export default ArtworkQualityAlert;
